import { SessionUserSelectors } from '~selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../app/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IGroupInfo } from '../../../ts/models/IGroupInfo';
import { syncAdGroup } from '../actions/GroupMenuActions';

export const SyncActiveDirectoryGroupAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.SynchronizeGroup,
  translateName: Messages.synchronize_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    return targetItems.length === 1
      && SessionUserSelectors.canManageUsers(state)
      && !targetItems[0].isAllUsersGroup
      && isActiveDirectoryGroup(targetItems[0]);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IGroupInfo[]) => syncAdGroup(targetItems)
};

function isActiveDirectoryGroup(group: IGroupInfo): boolean {
  return (group.domainName && group.domainName !== 'local');
}
